import type { TDBSystemCode } from '@home/types/aiSearch';

/** 收藏 URL 解析权限枚举 */
export enum Permission {
  /** 无页面访问权限 */
  NoPermission = '0',
  /** 有页面访问权限 */
  HasPermission = '1',
}

/** 收藏 URL 解析状态枚举 */
export enum Status {
  /** 页面或实体不可用 */
  Unavailable = '0',
  /** 页面或实体可用 */
  Available = '1',
}

export const URL_COLLECTION_ANALYSIS_FAILURE_REASON = {
  InvalidUrl: 'invalid_url',
  UnsupportedSystem: 'unsupported_system',
  UnsupportedUrl: 'unsupported_url',
  NoPermission: 'no_permission',
  Unavailable: 'unavailable',
  HandlerError: 'handler_error',
  Unknown: 'unknown',
} as const;

export type IAnalysisUrlInfoFailureReason =
  (typeof URL_COLLECTION_ANALYSIS_FAILURE_REASON)[keyof typeof URL_COLLECTION_ANALYSIS_FAILURE_REASON];

/** 收藏 URL 解析实体类型枚举 */
export enum EntityType {
  /** 手游 */
  Mobile = 'mobile',
  /** 端游 */
  PC = 'pc',
  /** 主机游戏 */
  Console = 'console',
  /** 融合游戏 */
  Combine = 'combine',
  /** 公司 */
  Company = 'company',
}

/** 收藏 URL 解析入参 */
export interface IAnalysisUrlInfoParams {
  /** 用户传入的原始 URL */
  url: string;
  /** 总入口归一后的 pathname + search，仅供子系统解析使用 */
  page_path?: string;
}

/** 收藏 URL 解析结果 */
export interface IAnalysisUrlInfoResult {
  /** 是否解析成功 */
  success: boolean;
  /** 解析失败原因 */
  failure_reason?: IAnalysisUrlInfoFailureReason;
  /** 解析出的系统 code */
  system?: TDBSystemCode | '';
  /** 页面访问权限 */
  permission: Permission;
  /** 页面或实体状态 */
  status: Status;
  /** 实体类型，非实体页时为空数组 */
  entity_type?: EntityType[];
  /** 实体 id，非实体页时为空 */
  entity_id?: string;
  /** 实体名称，非实体页时为空 */
  entity_name?: string;
  /** 实体封面，非实体页时为空 */
  entity_cover?: string;
  /** 用户传入的原始 URL */
  page_url: string;
  /** 归一后的页面路径，格式为 pathname + search */
  page_path: string;
  /** 页面名称 */
  page_name: string;
  /** 预留扩展字段 */
  data?: string;
}

/**
 * 收藏url解析器函数类型定义。
 * 接收一个包含 URL 的参数对象，返回一个 Promise，解析结果为 IAnalysisUrlInfoResult 类型。
 */
export type IAnalysisUrlInfoHandler = (params: IAnalysisUrlInfoParams) => Promise<IAnalysisUrlInfoResult>;

/** 收藏实体详情查询结果类型定义 */
export type IGetEntityDetailsByIdResult = Pick<
IAnalysisUrlInfoResult,
'entity_type' | 'entity_id' | 'entity_name' | 'entity_cover'
>;

/** 收藏实体详情查询函数类型定义 */
export type IGetEntityDetailsByIdHandler = (params: IAnalysisUrlInfoResult) => Promise<IGetEntityDetailsByIdResult>;
